import React from "react";
import { ScrollView, StyleSheet, View } from "react-native";
import Header from "./Header";
import WithdrawContent from "./WithdrawContent";

class WithdrawFromAcc extends React.Component {
  state = {
    bankSelected: true,
    upiSelected: false,
  };

  render() {
    const { item, from } = this.props.route.params;
    const { navigation } = this.props;

    return (
      <View style={styles.container}>
        <Header navigation={navigation} from={from} />
        <ScrollView keyboardShouldPersistTaps="always">
          <WithdrawContent from={from} item={item} navigation={navigation} />
        </ScrollView>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#f7f7f7",
  },
});

export default WithdrawFromAcc;
